module.exports = __webpack_public_path__ + "img/03-thumb.f86e97fa.png";